import { create } from "zustand";

interface NewTeamMember {
  verificationToken?: string;
  phoneNumber?: string;
}

export interface SignUpTeamMemberStoreState {
  newTeamMember?: NewTeamMember;
  setNewTeamMember: (newTeamMember: NewTeamMember) => void;
  currentStep: number;
  nextStep(): void;
  previousStep(): void;
  skipStep(amountToSkip: number): void;
  resetStep(): void;
}

export const useOnSignUpTeamMemberStore = create<SignUpTeamMemberStoreState>()(
  (set, get) => ({
    newTeamMember: undefined,
    setNewTeamMember: (newTeamMember: NewTeamMember) => {
      set(() => ({ newTeamMember }));
    },
    currentStep: 0,
    resetStep: () => {
      set(() => ({
        currentStep: 0,
      }));
    },
    nextStep: () => {
      const step = get().currentStep;
      set(() => ({
        currentStep: step + 1,
      }));
    },
    previousStep: () => {
      const step = get().currentStep;
      set(() => ({
        currentStep: step - 1,
      }));
    },
    skipStep: (amountToSkip: number) => {
      const step = get().currentStep;
      set(() => ({
        currentStep: step + amountToSkip,
      }));
    },
  }),
);
